'use strict';

var util = angular.module('gymsystem.util');

util.controller('RBListModal', ['$scope', '$filter', 'resourceBooking', 'rbookingList', 'fileManager', 'live', 'server',
    function($scope, $filter, $resourceBooking, rbookingList, $fileManager, $live, server) {

    var service = $scope.getPointerById(rbookingList.rbservice_id, $scope.resourcebookingservices);
    $scope.title = service.name + ',  ' + rbookingList.start.yyyymmdd() + ', ' + rbookingList.start.hhmm() + ' - ' + rbookingList.end.hhmm();

    var rbookings = rbookingList.resource_booking;

    var shallowComparator = function(obj, text) {
        if (!text || !obj) {
            return false;
        }
        if (typeof obj === 'object') {
            return false;
        }
        text = (''+text).toLowerCase();
        return (''+obj).toLowerCase().indexOf(text) > -1;
    };

    var shallowSearch = function(obj, text) {
        return _.values(obj).some(function(o) { return shallowComparator(o, text); } );
    };

    $scope.tableControl = {};
    $scope.tableList = {};
    $scope.tableList = {
        getItems: function() {
            return rbookings;
        },
        rowClass: function(rbooking) {
            return (rbooking && rbooking.paid)?'':'danger';
        },
        countSuffixList: ['booking', 'GENERAL_BOOKINGS'],
        headerClass: 'glyphicon glyphicon-credit-card',
        hideSearch: false,
        rowClick: function(rbooking) {
            $resourceBooking.openById(rbooking.id);
        },
        columns: [{
            field: 'image',
            src: function(rbooking) {
                var member = $scope.getMember(rbooking.user_id);
                return $fileManager.fileLinkByObject(member, 50);
            }
        }, {
            field: 'name',
            title: 'Name',
            placeHolderUid: rbooking => {
                const member = $scope.getMember(rbooking.user_id);
                return member?.is_placeholder ? member.uid : null;
            },
            getValue: function(rbooking) {
                var member = $scope.getMember(rbooking.user_id);
                // member can be null/undefined (e.g. booking without user_id, or
                // a member not in the loaded member list). Guard against it -
                // otherwise the whole list fails to render.
                var name = (member?.fullname) || '';
                if (rbooking.note) {
                    name += ' *';
                }
                return name;
            }
        }, {
            field: 'extra_person',
            title: 'Booked persons',
            getValue: function(rbooking) {
                return _.pluck(rbooking.extra_person, 'name').join(', ');
            }
        }, {
            field: 'price',
            title: 'Price',
            getValue: function(rbooking) {
                var total = +rbooking.price;
                if(rbooking.products && rbooking.products.length) {
                    rbooking.products.forEach(function(p) {
                        //add price only if product is not included
                        if(!rbooking.included_products?.includes(p.id)) {
                            total += +p.price;
                        };
                    });
                }
                return $scope.formatAmount(total);
            }
        }, {
            field: 'present',
            title: 'Present',
            format: 'bool'
        }],
        customSearch: function(item, searchText) {
            var member = $scope.getMember(item.user_id);
            if (shallowSearch(member, searchText)) {
                return true;
            }
            for (var i=0; i < (item.extra_person ? item.extra_person.length : 0); ++i) {
                if (shallowSearch(item.extra_person[i], searchText)) {
                    return true;
                }
            }

            return false;
        }
    };

    function rebuild() {
        if($scope.tableControl.update) {
            $scope.tableControl.update();
        }
    }

    $live.subscribe({
        type: 'resourcebooking',
        scope: $scope,
        callback: function(rbooking) {
            $scope.transformResourceBooking(rbooking);
            for(var i=0;i<rbookings.length;i++) {
                if(rbookings[i].id != rbooking.id) {continue;}
                rbookings.splice(i, 1);
                if(rbooking.cancelled) {
                    rebuild();
                    return;
                }
                break;
            }
            // check allocation
            if((rbooking.service_id == rbookingList.rbservice_id) &&
                    (rbooking.start <= rbookingList.end) &&
                    (rbooking.end >= rbookingList.start)) {
                if((rbooking.staff_id == rbookingList.resource_id) || (rbooking.xstaff_id == rbookingList.resource_id)) {
                    if(!rbooking.cancelled) {
                        rbookings.push(rbooking);
                    }
                    rebuild();
                    return;
                }

                server.post2('/api/resourcebooking/resource/get_resource_allocation', {
                    resource_ids: [rbookingList.resource_id],
                    start: rbookingList.start,
                    end: rbookingList.end
                }).then(function(result) {
                    rbookings.length = 0;
                    result.forEach(function(ra) {
                        if(ra.origin_type != 'ResourceBooking') {return;}
                        if(ra.origin.service_id != rbookingList.rbservice_id) {return;}
                        //if(!ra.start.isSameDateAs(rbookingList.start)) {return;}
                        //if(!ra.end.isSameDateAs(rbookingList.end)) {return;}
                        rbookings.push(ra.origin);
                    });
                    rebuild();
                });


            } else {
                rebuild();
            }
        }
    });

}]);
